import { FC, useEffect, useRef } from "react";
import { TV_CHART_COLORS, TV_COMMON } from "../theme";

interface SymbolOverViewWidgetProps {
  symbol: string;
}

export const SymbolOverViewWidget: FC<SymbolOverViewWidgetProps> = ({
  symbol,
}) => {
  const widgetRef = useRef(null);

  useEffect(() => {
    if (widgetRef.current && symbol) {
      const script = document.createElement("script");
      script.src =
        "https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js";
      script.async = true;
      /* The one embed on this page that was never themed: it came with
         TradingView's own blue-and-white chart, its own grid and its own
         type colours, on a page where every other widget had been brought
         onto the product's palette. */
      script.innerHTML = JSON.stringify({
        symbols: [[symbol]],
        width: "100%",
        /* Stated, so the frame around it can state the height the scale
           leaves. Without one, the widget picked its own and the card
           finished on a band of blank paper below the chart. */
        height: 460,
        chartOnly: false,
        ...TV_COMMON,
        ...TV_CHART_COLORS,
      });
      widgetRef.current.appendChild(script);
    }
  }, [symbol]);
  return <div ref={widgetRef} />;
};
